import { JSX } from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton, SelectField, SelectInput, required
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";

const addressFilters: JSX.Element[] = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Line One" source="line_one" name="line_one" />,
    <TextInput label="Country" source="country" name="country" />,
    <TextInput label="Postcode" source="postcode" name="postcode" />,
];

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

const ListTitle: () => JSX.Element = (): JSX.Element => {
    return (
        <span>
            { 'Companies House Registered Addresses' }
        </span>
    );
}

export const AdminCompaniesHouseAddressesList: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return(
        <List
            title={ <ListTitle /> }
            actions={ <ListActions /> }
            filters={ addressFilters } >
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <TextField source="line_one" />
                { (loading) &&
                    <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                }
                { (!loading) &&
                    <SelectField
                        choices={ loadedCountries }
                        source="country"
                    />
                }

                <ReferenceField
                    label="Companies House For"
                    source="companiesHouse"
                    reference="companies_houses"
                    link="show">
                    <TextField source="companyName" />
                </ReferenceField>
                <>
                    <ShowButton />
                    <EditButton />
                </>
            </Datagrid>
        </List>
    );
}